import React, { useEffect, useState } from 'react'

import { useNavigate } from 'react-router-dom'
import { ExclamationTriangleIcon } from '@heroicons/react/20/solid'
import { GET_ROUTE_TRIP_SCHEDULED_INFO } from 'graphql/route/queries'
import { useLazyQuery } from '@apollo/client'
import { customDateFormat } from 'utils/common'

const TripAlert = () => {
    const navigate = useNavigate()
    const [maxTripDate, setMaxTripDate] = useState('')

    const [getRouteList, { loading: routeListLoading, error: routeListError }] = useLazyQuery(
        GET_ROUTE_TRIP_SCHEDULED_INFO,
        {
            fetchPolicy: 'network-only',
            notifyOnNetworkStatusChange: true,
            onCompleted: data => {
                if (data.getRouteTripScheduledInfo.success && data.getRouteTripScheduledInfo.code === '200') {
                    setMaxTripDate(data.getRouteTripScheduledInfo.max_trip_date)
                }
            },
        }
    )

    useEffect(() => {
        getRouteList()
    }, [])

    return (
        <div className="border-l-4 border-[#fdc700] bg-[#fefce8] p-4 mb-4">
            <div className="flex items-center">
                <div className="shrink-0">
                    <ExclamationTriangleIcon aria-hidden="true" className="size-7 text-[#fdc700]" />
                </div>
                <div className="ml-3">
                    <p className="text-sm text-[#a65f00]">
                        <span className="font-semibold text-[#a65f00]">Scheduled Trips :</span> Trips are scheduled
                        until <strong>{customDateFormat(maxTripDate)}</strong> based on earlier configuration. Any
                        changes to existing routes, trips, or captains will not affect already scheduled trips. If you
                        wish to make changes to scheduled trips, please visit the{' '}
                        <button
                            onClick={() => navigate('/route-operations')}
                            className="font-medium text-[#a65f00] underline hover:text-yellow-600"
                        >
                            trip management page.
                        </button>
                    </p>
                </div>
            </div>
        </div>
    )
}

export default TripAlert
